import React from 'react';
import { Routes as RouterRoutes, Route } from 'react-router-dom';

// Page imports
import ProjectDashboard from './pages/project-dashboard';
import VisualBuilder from './pages/visual-builder';
import AIAppGenerator from './pages/ai-app-generator';
import TemplateMarketplace from './pages/template-marketplace';
import AssetManager from './pages/asset-manager';
import ProjectSettings from './pages/project-settings';
import UserProfile from './pages/user-profile';
import Login from './pages/login';
import Register from './pages/register';
import CheckoutPage from "./pages/checkout";
import SubscriptionManagement from "./pages/subscription-management";
import PaymentMethods from './pages/payment-methods';
import OrderConfirmation from './pages/order-confirmation';
import AlternativePaymentOptions from './pages/alternative-payment-options';
import PaymentHistory from 'pages/payment-history';
import EmailVerification from './pages/email-verification';
import NotFound from './pages/NotFound';
import WorkspaceSetup from "pages/workspace-setup";

export default function AppRoutes() {
  return (
    <RouterRoutes>
      <Route path="/" element={<ProjectDashboard />} />
      <Route path="/project-dashboard" element={<ProjectDashboard />} />
      <Route path="/workspace-setup" element={<WorkspaceSetup />} />
      <Route path="/visual-builder" element={<VisualBuilder />} />
      <Route path="/ai-app-generator" element={<AIAppGenerator />} />
      <Route path="/template-marketplace" element={<TemplateMarketplace />} />
      <Route path="/asset-manager" element={<AssetManager />} />
      <Route path="/project-settings" element={<ProjectSettings />} />
      <Route path="/payment-methods" element={<PaymentMethods />} />
      <Route path="/subscription-management" element={<SubscriptionManagement />} />
      <Route path="/payment-history" element={<PaymentHistory />} />
      <Route path="/email-verification" element={<EmailVerification />} />
      <Route path="/user-profile" element={<UserProfile />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/checkout" element={<CheckoutPage />} />
      <Route path="/order-confirmation" element={<OrderConfirmation />} />
      <Route path="/alternative-payment-options" element={<AlternativePaymentOptions />} />
      <Route path="*" element={<NotFound />} />
    </RouterRoutes>
  );
}